// AcademicStaffPage.js - Adam International Academy Documents Version
import React, { useState, useEffect, useRef } from 'react';
import './AcademicStaffPage.css';

// Import images
import president from '../../assets/AcademicStaffPage/president.jpg';
import abdulnasirImg from '../../assets/AcademicStaffPage/Abdulnasir Munir.jpg';
import hammanadam from '../../assets/AcademicStaffPage/hammanadam.jpg';
import nabilbukairy from '../../assets/AcademicStaffPage/nabilbukairy.jpg';
import najib from '../../assets/AcademicStaffPage/najib.jpg';
import samiralbuny from '../../assets/AcademicStaffPage/samiralbuny.jpg';
import ayseDemirImg from '../../assets/about/about-hero.jpg';
import staffBanner from '../../assets/AcademicStaffPage/staff-banner.jpg';

// Dummy images for additional staff members
import dummy1 from '../../assets/AcademicStaffPage/president.jpg';
import dummy2 from '../../assets/AcademicStaffPage/Abdulnasir Munir.jpg';
import dummy3 from '../../assets/AcademicStaffPage/hammanadam.jpg';
import dummy4 from '../../assets/AcademicStaffPage/nabilbukairy.jpg';
import dummy5 from '../../assets/AcademicStaffPage/najib.jpg';
import dummy6 from '../../assets/AcademicStaffPage/samiralbuny.jpg';

// Faculty members data from documents
const facultyMembers = [
  {
    id: 1,
    name: "Prof. Dr. M. Haydar",
    title: "Founder & President, Strategic Leadership",
    background: "Istanbul University, University of Cambridge, Harvard Business School",
    expertise: "Strategic management, institutional development, capacity building",
    research: "Leadership development programs, organizational transformation",
    email: "m.haydar@adaminternationalacademy.com",
    image: president,
    specialties: ["Strategic Leadership", "Institutional Development", "Capacity Building"],
    country: "Turkey",
    sectors: ["Education", "Consultancy", "Sustainable Development"]
  },
  {
    id: 2,
    name: "Prof. Dr. Abdulnasir Munir",
    title: "Economic Development & Policy Analysis",
    background: "London School of Economics, University of Oxford",
    expertise: "Economic policy, sustainable development, SDG implementation",
    research: "Economic feasibility studies, development economics",
    email: "abdulnasir.munir@adaminternationalacademy.com",
    image: abdulnasirImg,
    specialties: ["Economic Development", "Policy Analysis", "SDG Implementation"],
    country: "UK",
    sectors: ["Economy", "Sustainable Development", "Consultancy"]
  },
  {
    id: 3,
    name: "Prof. Dr. Hamman Adam",
    title: "International Relations & Diplomacy",
    background: "Sorbonne University, Georgetown University",
    expertise: "International law, diplomacy, multilateral negotiations",
    research: "Global governance, international organizations",
    email: "hamman.adam@adaminternationalacademy.com",
    image: hammanadam,
    specialties: ["International Relations", "Diplomacy", "International Law"],
    country: "France",
    sectors: ["Consultancy", "Education", "Services"]
  },
  {
    id: 4,
    name: "Prof. Dr. Nabil Bukairy",
    title: "Engineering & Project Management",
    background: "MIT, Stanford University, King Fahd University",
    expertise: "Construction management, infrastructure development, renewable energy",
    research: "Sustainable engineering, project optimization",
    email: "nabil.bukairy@adaminternationalacademy.com",
    image: nabilbukairy,
    specialties: ["Engineering Management", "Project Management", "Renewable Energy"],
    country: "Saudi Arabia",
    sectors: ["Construction", "Technology", "Industry"]
  },
  {
    id: 5,
    name: "Prof. Dr. Najib Al-Rahman",
    title: "Legal Studies & International Arbitration",
    background: "Harvard Law School, University of Cambridge",
    expertise: "International law, commercial arbitration, dispute resolution",
    research: "Engineering and commercial arbitration",
    email: "najib.rahman@adaminternationalacademy.com",
    image: najib,
    specialties: ["International Law", "Arbitration", "Dispute Resolution"],
    country: "Egypt",
    sectors: ["Consultancy", "Services", "Legal"]
  },
  {
    id: 6,
    name: "Prof. Dr. Samir Albuny",
    title: "Technology & Digital Transformation",
    background: "MIT Media Lab, Stanford University",
    expertise: "Artificial Intelligence, digital transformation, cybersecurity",
    research: "AI in education, digital innovation",
    email: "samir.albuny@adaminternationalacademy.com",
    image: samiralbuny,
    specialties: ["Artificial Intelligence", "Digital Transformation", "Cybersecurity"],
    country: "UAE",
    sectors: ["Technology", "Innovation", "Education"]
  },
  {
    id: 7,
    name: "Prof. Dr. Ayşe Demir",
    title: "Sustainable Development & SDG Strategy",
    background: "Boğaziçi University, Columbia University, UNDP Consultant",
    expertise: "SDG 2030 implementation, sustainability strategy, gender equality",
    research: "Multilingual education, capacity development",
    email: "ayse.demir@adaminternationalacademy.com",
    image: ayseDemirImg,
    specialties: ["Sustainable Development", "SDG Strategy", "Gender Equality"],
    country: "Turkey",
    sectors: ["Sustainable Development", "Education", "Consultancy"]
  },
  {
    id: 8,
    name: "Prof. Dr. John Smith",
    title: "Corporate Governance & Compliance (GRC)",
    background: "University of Oxford, London Business School",
    expertise: "Corporate governance, risk management, compliance",
    research: "Ethical leadership, corporate responsibility",
    email: "john.smith@adaminternationalacademy.com",
    image: dummy1,
    specialties: ["Corporate Governance", "Risk Management", "Compliance"],
    country: "UK",
    sectors: ["Consultancy", "Economy", "Services"]
  },
  {
    id: 9,
    name: "Prof. Dr. Zeynep Kaya",
    title: "Human Resources & Organizational Development",
    background: "LSE, INSEAD, Cornell University",
    expertise: "HR strategy, talent management, leadership development",
    research: "Women in leadership, organizational culture",
    email: "zeynep.kaya@adaminternationalacademy.com",
    image: dummy2,
    specialties: ["Human Resources", "Organizational Development", "Talent Management"],
    country: "Turkey",
    sectors: ["Services", "Consultancy", "Education"]
  },
  {
    id: 10,
    name: "Prof. Dr. Ali Yılmaz",
    title: "Data Science & Business Intelligence",
    background: "MIT, Carnegie Mellon University",
    expertise: "Big data analytics, business intelligence, decision support systems",
    research: "Data-driven decision making, predictive analytics",
    email: "ali.yilmaz@adaminternationalacademy.com",
    image: dummy3,
    specialties: ["Data Science", "Business Intelligence", "Analytics"],
    country: "Turkey",
    sectors: ["Technology", "Innovation", "Industry"]
  },
  {
    id: 11,
    name: "Dr. Emily Johnson",
    title: "Occupational Health, Safety & Environment (HSE)",
    background: "Johns Hopkins University, CDC",
    expertise: "Occupational safety, environmental health, risk assessment",
    research: "Workplace safety, environmental sustainability",
    email: "emily.johnson@adaminternationalacademy.com",
    image: dummy4,
    specialties: ["HSE Management", "Environmental Health", "Risk Assessment"],
    country: "USA",
    sectors: ["Services", "Industry", "Construction"]
  },
  {
    id: 12,
    name: "Prof. Dr. Michael Brown",
    title: "Innovation & Entrepreneurship",
    background: "Stanford University, UC Berkeley",
    expertise: "Innovation management, entrepreneurship, business incubation",
    research: "Startup ecosystems, innovation strategies",
    email: "michael.brown@adaminternationalacademy.com",
    image: dummy5,
    specialties: ["Innovation", "Entrepreneurship", "Business Incubation"],
    country: "USA",
    sectors: ["Technology", "Consultancy", "Services"]
  },
  {
    id: 13,
    name: "Prof. Dr. Sarah Wilson",
    title: "Public Policy & Government Relations",
    background: "Harvard Kennedy School, Princeton University",
    expertise: "Public policy analysis, government relations, policy formulation",
    research: "Evidence-based policy making",
    email: "sarah.wilson@adaminternationalacademy.com",
    image: dummy6,
    specialties: ["Public Policy", "Government Relations", "Policy Analysis"],
    country: "USA",
    sectors: ["Consultancy", "Services", "Sustainable Development"]
  },
  {
    id: 14,
    name: "Prof. Dr. Robert Taylor",
    title: "Supply Chain & Logistics Management",
    background: "MIT, Cranfield University",
    expertise: "Supply chain optimization, logistics, procurement",
    research: "Sustainable supply chains, digital logistics",
    email: "robert.taylor@adaminternationalacademy.com",
    image: president,
    specialties: ["Supply Chain", "Logistics", "Procurement"],
    country: "UK",
    sectors: ["Commerce", "Industry", "Services"]
  },
  {
    id: 15,
    name: "Dr. Lisa Anderson",
    title: "Marketing & Strategic Communication",
    background: "Northwestern University, USC Annenberg",
    expertise: "Strategic marketing, brand management, corporate communication",
    research: "Digital marketing, consumer behavior",
    email: "lisa.anderson@adaminternationalacademy.com",
    image: samiralbuny,
    specialties: ["Strategic Marketing", "Corporate Communication", "Brand Management"],
    country: "USA",
    sectors: ["Commerce", "Services", "Consultancy"]
  },
  {
    id: 16,
    name: "Prof. Dr. James Wilson",
    title: "Financial Management & Investment",
    background: "University of Chicago Booth, London Business School",
    expertise: "Corporate finance, investment analysis, financial planning",
    research: "Investment strategies, financial risk management",
    email: "james.wilson@adaminternationalacademy.com",
    image: nabilbukairy,
    specialties: ["Financial Management", "Investment", "Corporate Finance"],
    country: "UK",
    sectors: ["Economy", "Services", "Consultancy"]
  },
  {
    id: 17,
    name: "Prof. Dr. Maria Garcia",
    title: "Renewable Energy & Sustainability",
    background: "Technical University of Berlin, ETH Zurich",
    expertise: "Renewable energy systems, energy policy, sustainability",
    research: "Solar energy, wind power, energy efficiency",
    email: "maria.garcia@adaminternationalacademy.com",
    image: najib,
    specialties: ["Renewable Energy", "Sustainability", "Energy Policy"],
    country: "Spain",
    sectors: ["Technology", "Industry", "Sustainable Development"]
  },
  {
    id: 18,
    name: "Prof. Dr. David Lee",
    title: "Construction & Urban Planning",
    background: "National University of Singapore, Delft University",
    expertise: "Urban planning, infrastructure development, smart cities",
    research: "Sustainable urban development, smart city technologies",
    email: "david.lee@adaminternationalacademy.com",
    image: abdulnasirImg,
    specialties: ["Urban Planning", "Construction Management", "Smart Cities"],
    country: "Singapore",
    sectors: ["Construction", "Technology", "Services"]
  },
  {
    id: 19,
    name: "Dr. Susan Chen",
    title: "Cybersecurity & Information Security",
    background: "Carnegie Mellon University, Stanford University",
    expertise: "Cybersecurity strategy, information security, data protection",
    research: "Blockchain security, AI in cybersecurity",
    email: "susan.chen@adaminternationalacademy.com",
    image: hammanadam,
    specialties: ["Cybersecurity", "Information Security", "Data Protection"],
    country: "China",
    sectors: ["Technology", "Innovation", "Services"]
  },
  {
    id: 20,
    name: "Prof. Dr. Richard Kim",
    title: "International Trade & Commerce",
    background: "University of Tokyo, Seoul National University",
    expertise: "International trade, export-import, trade policy",
    research: "Global supply chains, trade agreements",
    email: "richard.kim@adaminternationalacademy.com",
    image: dummy1,
    specialties: ["International Trade", "Commerce", "Trade Policy"],
    country: "South Korea",
    sectors: ["Commerce", "Economy", "Services"]
  },
  {
    id: 21,
    name: "Dr. Amanda White",
    title: "Educational Technology & e-Learning",
    background: "Harvard Graduate School of Education, MIT Media Lab",
    expertise: "e-Learning design, instructional technology, MOOCs",
    research: "Multilingual e-learning, mobile learning",
    email: "amanda.white@adaminternationalacademy.com",
    image: dummy2,
    specialties: ["e-Learning", "Educational Technology", "Instructional Design"],
    country: "Australia",
    sectors: ["Education", "Technology", "Innovation"]
  },
  {
    id: 22,
    name: "Prof. Dr. Thomas Martin",
    title: "Healthcare Management",
    background: "Johns Hopkins University, Mayo Clinic",
    expertise: "Healthcare administration, hospital management, health policy",
    research: "Healthcare quality improvement, patient safety",
    email: "thomas.martin@adaminternationalacademy.com",
    image: dummy3,
    specialties: ["Healthcare Management", "Hospital Administration", "Health Policy"],
    country: "USA",
    sectors: ["Services", "Consultancy", "Sustainable Development"]
  },
  {
    id: 23,
    name: "Prof. Dr. Nancy Adams",
    title: "Women Empowerment & Leadership",
    background: "Smith College, Wellesley College",
    expertise: "Gender studies, women in leadership, diversity",
    research: "LEADWomen program, gender equality in organizations",
    email: "nancy.adams@adaminternationalacademy.com",
    image: dummy4,
    specialties: ["Women Empowerment", "Gender Studies", "Diversity Leadership"],
    country: "Canada",
    sectors: ["Services", "Consultancy", "Sustainable Development"]
  },
  {
    id: 24,
    name: "Dr. Kevin Zhang",
    title: "Artificial Intelligence & Machine Learning",
    background: "Stanford University, Tsinghua University",
    expertise: "Machine learning, deep learning, AI applications",
    research: "AI in education, natural language processing",
    email: "kevin.zhang@adaminternationalacademy.com",
    image: dummy5,
    specialties: ["Artificial Intelligence", "Machine Learning", "Deep Learning"],
    country: "China",
    sectors: ["Technology", "Innovation", "Education"]
  },
  {
    id: 25,
    name: "Prof. Dr. Christopher Taylor",
    title: "Crisis Management & Strategic Planning",
    background: "West Point, Naval War College",
    expertise: "Crisis management, strategic planning, decision-making",
    research: "Organizational resilience, crisis communication",
    email: "christopher.taylor@adaminternationalacademy.com",
    image: dummy6,
    specialties: ["Crisis Management", "Strategic Planning", "Decision Making"],
    country: "USA",
    sectors: ["Consultancy", "Services", "Sustainable Development"]
  },
  {
    id: 26,
    name: "Dr. Olivia Harris",
    title: "Creative Industries & Design Thinking",
    background: "Rhode Island School of Design, Parsons",
    expertise: "Design thinking, creative leadership, innovation",
    research: "Creativity in organizations, design-led innovation",
    email: "olivia.harris@adaminternationalacademy.com",
    image: president,
    specialties: ["Design Thinking", "Creative Leadership", "Innovation"],
    country: "UK",
    sectors: ["Innovation", "Technology", "Services"]
  },
  {
    id: 27,
    name: "Prof. Dr. Ahmed Hassan",
    title: "Oil & Gas Engineering",
    background: "King Fahd University, Texas A&M University",
    expertise: "Petroleum engineering, gas processing, energy management",
    research: "Sustainable energy, oil & gas optimization",
    email: "ahmed.hassan@adaminternationalacademy.com",
    image: samiralbuny,
    specialties: ["Oil & Gas", "Energy Management", "Petroleum Engineering"],
    country: "UAE",
    sectors: ["Industry", "Technology", "Sustainable Development"]
  },
  {
    id: 28,
    name: "Prof. Dr. Fatima Al-Sayed",
    title: "Quality Management & Six Sigma",
    background: "Cairo University, American University in Cairo",
    expertise: "Quality management, Six Sigma, process improvement",
    research: "Total Quality Management (TQM), organizational excellence",
    email: "fatima.alsayed@adaminternationalacademy.com",
    image: nabilbukairy,
    specialties: ["Quality Management", "Six Sigma", "Process Improvement"],
    country: "Egypt",
    sectors: ["Industry", "Services", "Consultancy"]
  }
];

// Expertise areas from documents
const expertiseAreas = [
  "Sustainable Development (SDGs)",
  "Multilingual Education",
  "Innovation & Technology",
  "Capacity Development",
  "Policy Analysis",
  "International Relations",
  "Digital Transformation",
  "Artificial Intelligence (AI)",
  "Data Science & Analytics",
  "Cybersecurity",
  "Project Management",
  "Corporate Governance",
  "Renewable Energy",
  "Engineering Consultancy",
  "Legal Studies & Arbitration",
  "Economic Feasibility",
  "Women Empowerment",
  "HSE Management",
  "Supply Chain & Logistics",
  "Financial Management"
];

// Advisory board members from documents
const advisoryBoard = [
  { name: "Prof. Dr. Ahmed Zaki", title: "Chairman of Board of Trustees", country: "Turkey" },
  { name: "Prof. Dr. Mehmet Bulut", title: "Board Member - Sabahattin Zaim University", country: "Turkey" },
  { name: "Prof. Dr. Ömer Çelik", title: "Board Member - Medipol University", country: "Turkey" },
  { name: "Dr. Sarah Ahmed", title: "Board Member - International Advisory", country: "UAE" },
  { name: "Prof. Dr. John Davis", title: "Board Member - American International Theism University", country: "USA" }
];

function AcademicStaffPage() {
  const [selectedExpertise, setSelectedExpertise] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [visibleSections, setVisibleSections] = useState({});
  const sectionRefs = useRef({});

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisibleSections(prev => ({
              ...prev,
              [entry.target.dataset.section]: true
            }));
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px' }
    );

    Object.values(sectionRefs.current).forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => {
      Object.values(sectionRefs.current).forEach(ref => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const filteredMembers = facultyMembers.filter(member => {
    const matchesExpertise = selectedExpertise === "All" || 
      member.specialties.some(specialty => specialty === selectedExpertise);
    const matchesSearch = member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.expertise.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.country.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesExpertise && matchesSearch;
  });

  const openModal = (member) => {
    setSelectedMember(member);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMember(null);
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  useEffect(() => {
    setIsFiltered(selectedExpertise !== "All" || searchTerm !== "");
  }, [selectedExpertise, searchTerm]);

  const renderStaffGrid = () => {
    if (filteredMembers.length === 0) {
      return (
        <div className="ap-no-results">
          <h3>No academic staff matching your search</h3>
          <p>Please try a different search term or expertise area.</p>
        </div>
      );
    }

    return (
      <div className="ap-staff-grid-layout">
        {!isFiltered && filteredMembers.length > 0 && (
          <div className="ap-staff-row ap-first-row">
            <div className="ap-staff-card featured" onClick={() => openModal(filteredMembers[0])}>
              <div className="ap-staff-image-container">
                <img src={filteredMembers[0].image} alt={filteredMembers[0].name} className="ap-staff-image" loading="lazy" />
              </div>
              <div className="ap-staff-info">
                <h3 className="ap-staff-name">{filteredMembers[0].name}</h3>
                <p className="ap-staff-title">{filteredMembers[0].title}</p>
                <p className="ap-staff-country">{filteredMembers[0].country}</p>
              </div>
            </div>
          </div>
        )}
        
        {filteredMembers.length > 1 && (
          <div className="ap-staff-row ap-second-row">
            {filteredMembers.slice(1, 4).map(member => (
              <div className="ap-staff-card" key={member.id} onClick={() => openModal(member)}>
                <div className="ap-staff-image-container">
                  <img src={member.image} alt={member.name} className="ap-staff-image" loading="lazy" />
                </div>
                <div className="ap-staff-info">
                  <h3 className="ap-staff-name">{member.name}</h3>
                  <p className="ap-staff-title">{member.title}</p>
                  <p className="ap-staff-country">{member.country}</p>
                </div>
              </div>
            ))}
          </div>
        )}
        
        {filteredMembers.length > 4 && (
          <div className="ap-staff-row ap-third-row">
            {filteredMembers.slice(4, 12).map(member => (
              <div className="ap-staff-card" key={member.id} onClick={() => openModal(member)}>
                <div className="ap-staff-image-container">
                  <img src={member.image} alt={member.name} className="ap-staff-image" loading="lazy" />
                </div>
                <div className="ap-staff-info">
                  <h3 className="ap-staff-name">{member.name}</h3>
                  <p className="ap-staff-title">{member.title}</p>
                </div>
              </div>
            ))}
          </div>
        )}
        
        {filteredMembers.length > 12 && (
          <div className="ap-staff-row ap-fourth-row">
            {filteredMembers.slice(12, 20).map(member => (
              <div className="ap-staff-card" key={member.id} onClick={() => openModal(member)}>
                <div className="ap-staff-image-container">
                  <img src={member.image} alt={member.name} className="ap-staff-image" loading="lazy" />
                </div>
                <div className="ap-staff-info">
                  <h3 className="ap-staff-name">{member.name}</h3>
                  <p className="ap-staff-title">{member.title}</p>
                </div>
              </div>
            ))}
          </div>
        )}
        
        {filteredMembers.length > 20 && (
          <div className="ap-staff-row ap-fifth-row">
            {filteredMembers.slice(20, 28).map(member => (
              <div className="ap-staff-card" key={member.id} onClick={() => openModal(member)}>
                <div className="ap-staff-image-container">
                  <img src={member.image} alt={member.name} className="ap-staff-image" loading="lazy" />
                </div>
                <div className="ap-staff-info">
                  <h3 className="ap-staff-name">{member.name}</h3>
                  <p className="ap-staff-title">{member.title}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="ap-wrapper">
      {/* Hero Section - Updated */}
      <section className="ap-hero" style={{backgroundImage: `url(${ayseDemirImg})`}}>
        <div className="ap-hero-overlay">
          <div className="ap-hero-content">
            <h1>Academic Faculty & Experts</h1>
            <p>High-level professionals from 30+ countries, committed to excellence in capacity development and innovation.</p>
          </div>
        </div>
      </section>

      {/* Introduction Section - Updated from documents */}
      <section 
        className="ap-section ap-intro-section"
        ref={el => sectionRefs.current.intro = el}
        data-section="intro"
      >
        <div className={`ap-container ap-section-content ${visibleSections.intro ? 'visible' : ''}`}>
          <div className="ap-section-text">
            <h2 className="ap-section-title">Meet Our Global Faculty</h2>
            <p>
              At Adam International Academy, we take pride in our distinguished academic staff from approximately 
              <strong> 30 countries</strong> around the world. Our faculty members are high-level professionals, 
              committed, dedicated, and extremely reliable, who make the success of the AIA e-Learning Academy.
            </p>
            <p>
              The Scientific Body includes about <strong>100 academics and experts</strong> who participate regularly 
              or remotely in the Academy's programs, activities, and events. They bring expertise in sustainable 
              development, international relations, engineering, technology, and all nine sectors of Adam Holding Union.
            </p>
            <div className="ap-stats">
              <div className="ap-stat">
                <span className="ap-stat-number">100+</span>
                <span className="ap-stat-label">Faculty Members</span>
              </div>
              <div className="ap-stat">
                <span className="ap-stat-number">30+</span>
                <span className="ap-stat-label">Countries</span>
              </div>
              <div className="ap-stat">
                <span className="ap-stat-number">20+</span>
                <span className="ap-stat-label">Expertise Areas</span>
              </div>
              <div className="ap-stat">
                <span className="ap-stat-number">9</span>
                <span className="ap-stat-label">Sectors</span>
              </div>
            </div>
          </div>
          <img src={staffBanner} alt="Academic Team" className="ap-section-image" loading="lazy" />
        </div>
      </section>

      {/* Advisory Board Section - New from documents */}
      <section 
        className="ap-section ap-advisory-section"
        ref={el => sectionRefs.current.advisory = el}
        data-section="advisory"
      >
        <div className={`ap-container ${visibleSections.advisory ? 'visible' : ''}`}>
          <h2 className="ap-section-title">👥 Advisory Board</h2>
          <div className="ap-advisory-grid">
            {advisoryBoard.map((member, index) => (
              <div key={index} className="ap-advisory-card">
                <h3>{member.name}</h3>
                <p>{member.title}</p>
                <span className="ap-advisory-country">{member.country}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Filter Section - Updated */}
      <section 
        className="ap-section"
        ref={el => sectionRefs.current.filter = el}
        data-section="filter"
      >
        <div className={`ap-container ${visibleSections.filter ? 'visible' : ''}`}>
          <h2 className="ap-section-title">🎯 Areas of Expertise</h2>
          <div className="ap-expertise-filter">
            <div className="ap-search-box">
              <input
                type="text"
                placeholder="Search faculty by name, title, expertise, or country..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="ap-search-input"
                aria-label="Search academic staff"
              />
              <span className="ap-search-icon">🔍</span>
            </div>
            
            <div className="ap-expertise-tags">
              <button
                className={`ap-tag ${selectedExpertise === "All" ? "active" : ""}`}
                onClick={() => setSelectedExpertise("All")}
                aria-label="Show all staff"
              >
                All Experts
              </button>
              {expertiseAreas.map((area, index) => (
                <button
                  key={index}
                  className={`ap-tag ${selectedExpertise === area ? "active" : ""}`}
                  onClick={() => setSelectedExpertise(area)}
                  aria-label={`Filter by ${area}`}
                >
                  {area}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Staff Profiles */}
      <section 
        className="ap-section ap-staff-section"
        ref={el => sectionRefs.current.staff = el}
        data-section="staff"
      >
        <div className={`ap-container ${visibleSections.staff ? 'visible' : ''}`}>
          {renderStaffGrid()}
        </div>
      </section>

      {/* Member Detail Modal - Updated with more fields */}
      {isModalOpen && selectedMember && (
        <div className="ap-modal-overlay" onClick={closeModal}>
          <div className="ap-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ap-modal-close" onClick={closeModal} aria-label="Close modal">×</button>
            
            <div className="ap-modal-body">
              <div className="ap-modal-image">
                <img src={selectedMember.image} alt={selectedMember.name} loading="lazy" />
              </div>
              
              <div className="ap-modal-info">
                <h2>{selectedMember.name}</h2>
                <p className="ap-modal-title">{selectedMember.title}</p>
                <p className="ap-modal-country">📍 {selectedMember.country}</p>
                
                <div className="ap-modal-details">
                  <div className="ap-modal-detail">
                    <h4>Academic Background</h4>
                    <p>{selectedMember.background}</p>
                  </div>
                  
                  <div className="ap-modal-detail">
                    <h4>Area of Expertise</h4>
                    <p>{selectedMember.expertise}</p>
                  </div>
                  
                  <div className="ap-modal-detail">
                    <h4>Research Areas</h4>
                    <p>{selectedMember.research}</p>
                  </div>
                  
                  <div className="ap-modal-detail">
                    <h4>Sectors</h4>
                    <div className="ap-modal-sectors">
                      {selectedMember.sectors.map((sector, index) => (
                        <span key={index} className="ap-modal-sector">{sector}</span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="ap-modal-detail">
                    <h4>Specialties</h4>
                    <div className="ap-modal-specialties">
                      {selectedMember.specialties.map((specialty, index) => (
                        <span key={index} className="ap-modal-specialty">{specialty}</span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="ap-modal-contact">
                    <h4>Contact</h4>
                    <a href={`mailto:${selectedMember.email}`} className="ap-modal-email">
                      {selectedMember.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AcademicStaffPage;